<template>
  <div class="sidebar d-flex flex-column h-100">
    <div class="sidebar-title mb-4 px-3 py-4 align-self-start">
      <span>JEParts Admin</span>
    </div>
    <div class="sidebar-links d-flex flex-column h-100 justify-content-start">
      <sidebar-link to="/orders" icon="attach_money">Orders</sidebar-link>
      <sidebar-link to="/customers" icon="group">Customers</sidebar-link>
      <sidebar-link to="/employees" icon="settings" last>Employees</sidebar-link>
    </div>
    <div class="sidebar-signout">
      <i class="md-light md-48 material-icons">power_settings_new</i>
    </div>
  </div>
</template>

<script>
import SidebarLink from "@/components/SidebarLink";
export default {
  components: { SidebarLink },
  methods: {
    log() {
      console.log("clicked");
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar {
  background: {
    color: #333;
  }

  &-title {
    width: 100%;
    color: white;
    background: {
      color: #444;
    }
    font-weight: 700;
  }

  &-signout {
  }
}
</style>

